type VerificationPortal = { verifiable: boolean; isActive: boolean } | null | undefined;

/**
 * Why credential verification can't run against a portal, or null when it can.
 * Shared by the API and UI so the Verify action is only offered where the
 * server will run it.
 */
export function credentialVerificationUnavailableReason(portal: VerificationPortal): string | null {
  if (!portal?.verifiable) {
    return "Credential verification is not supported for this portal";
  }
  if (!portal.isActive) {
    return "Credential verification is unavailable now because the portal is inactive";
  }
  return null;
}

export function portalCanVerifyCredentials(portal: VerificationPortal): boolean {
  return credentialVerificationUnavailableReason(portal) === null;
}
